function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        viewBox: "0 0 8 6"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3.60356 5.78167L0.162504 1.20661C-0.0541677 0.92633 -0.0541677 0.492835 0.162504 0.212554C0.401882 -0.0509319 1.0103 0.00895119 1.0103 0.00895119L6.99475 0.00895119C6.99475 0.00895119 7.60317 -0.0629082 7.8226 0.200577C8.05119 0.476092 8.05996 0.918345 7.84255 1.20661L4.40149 5.78167C4.30109 5.92036 4.15556 6 4.00253 6C3.84949 6 3.70396 5.92036 3.60356 5.78167Z"
        })
    }));
};
export default Icon;
